export const useNavigation = () => {
    return {
        push: (url: string) => {
            window.location.href = url;
        },
    };
};
